export const routePathCapterPrefix = 'chapter';

export const routePath = {
  myProfile: 'my-profile',
  signUp: 'sign-up',
  login: 'login',
  myHistory: 'my-history',
  createPlace: 'create-place',
  chapters: 'chapters',
  chapter: routePathCapterPrefix + '/:id/:start/:end',
  facets: 'facets',
  facet: 'facets/:id',
  friends: 'friends',
  friendsList: 'friends-list',
  friendFacets: 'facets/:chapterId',
  friendsAllStories: 'friends-all-stories',
  friendStories: 'facets/:chapterId/stories/:facetId',
  friendStoriesByFacet: 'stories/:facetId',
  friend: 'friend/:followerId',
  friendPrefix: 'friend',
  friendChapters: '',
  story: 'stories/:id/:apiKey',
  stories: 'stories',
  storiesById: 'stories/:id',
  storiesByFacetPrefix: 'stories-by-facet',
  storiesByFacet: 'stories-by-facet/:facetId',
  storiesInChapter: 'stories/:chapterId/:facetId',
  guestOverview: 'guest-overview',
  termsConditions: 'terms-and-conditions',
  contactUs: 'contact-us',
  privacyPolicy: 'privacy-policy',
  trademarkAppealForm: 'trademark-appeal-form',
  privacyRequest: 'privacy-request',
  privacyPreferences: 'privacy-preferences',
  copyrightReport: 'copyright-report',
  privacyViolation: 'privacy-violation',
  setting: 'setting',
  notification: 'notification',
  privacy: 'privacy',
  replayTour: 'replay-tour',
  communities: 'communities',
  dashboard: 'dashboard',
  faq: 'faq',
  feed: 'feed',
  friendsFeed: 'friends-feed',
  allFeed: 'all-feed',
  communitiesFeed: 'communities-feed',
  feedManagement: 'feed-management',
  storyNotificationManagement: 'notification-management',
};
